export default __webpack_public_path__ + "static/media/facebook.9bb09900.svg";